import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface loaderProps {
  open: boolean;
}

export const Loader = ({open}: loaderProps) => {
  return (
    <>
      <Backdrop
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
          color: "#1976d2",
          opacity: 1,
          paddingLeft: "6%",
        }}
        open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
